import { useEffect, useRef } from "react";
import { trackEvent } from "@/App";

export function usePageTracking(pageName: string) {
  const lastVisit = useRef<string | null>(null);
  useEffect(() => {
    const visit = `${window.location.pathname}:${pageName}`;
    // React's development effect replay must not record a second page visit.
    if (lastVisit.current === visit) return;
    lastVisit.current = visit;
    trackEvent("page_view", window.location.pathname, { page: pageName });
  }, [pageName]);
}
